<template>
  <div class="messages-list">
    <empty-state v-if="!chatList.length"
                 type="messages"/>

    <div v-if="chatList.length"
         class="messages-list__list">
      <div v-for="(item, index) in chatList"
           :key="index"
           :class="$isMobile ? 'm-b-15' : 'm-b-20'">
        <component :is="getItemChatComponent(item)"
                   v-bind="item"
                   class="m-b-15 messages-list"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {
    GETTER_DOCTOR_PATIENT_PARTNER,
  } from '@/store/types';
  import {
    CHAT_ROUTE,
    MESSAGE_DOCTOR_PARAM,
    MESSAGE_PATIENT_ID_PARAM,
  } from '@/router/routes';
  import EmptyState from '@/components/empty-state';
  import ChatItemBill from '@/components/messages/chat-item-bill';
  import ChatItemOrder from '@/components/messages/chat-item-order';
  import ChatItemDoctor from '@/components/messages/chat-item-doctor';

  export default {
    name: 'messages-list',
    components: {
      EmptyState,
      ChatItemBill,
    },
    props: {
      chatList: {type: Array, default: () => []},
    },
    data() {
      return {
        error: null,
        loading: false,
      }
    },
    computed: {
      ...mapGetters({
        getDoctorPatientPair: GETTER_DOCTOR_PATIENT_PARTNER,
      }),
    },
    methods: {
      goToMessage(pairToken) {
        const {doctor, patient} = this.getDoctorPatientPair[pairToken];
        this.$router.push({
          name: CHAT_ROUTE,
          params: {
            [MESSAGE_DOCTOR_PARAM]: doctor.usertag,
            [MESSAGE_PATIENT_ID_PARAM]: patient.id,
          },
        });
      },
      getItemChatComponent(item) {
        if (item.pairToken) return ChatItemDoctor;
        if (item.order) return ChatItemOrder;
        if (item.bill) return ChatItemBill;
        return null;
      },
    },
  }
</script>

<style lang="scss">
  .messages-list {
    &__list {
      .smd-chat-status {
        cursor: pointer;

        &:not(:last-child) {
          margin-bottom: space(m);
        }

        .smd-profile-image {
          background-color: transparent;
        }

        .smd-notification-badge {
          right: 15px;
        }
      }
    }

    .messages-list {
      @include responsive(desktop) {
        grid-template-columns: 60px minmax(0, 1fr) 20px;
        min-height: 120px;
        padding: 30px;
        grid-column-gap: space(l);

        &:hover {
          box-shadow: $desktop-purple-hover;
        }

        .smd-chat-status__name {
          margin-bottom: space(s);
        }

        .smd-chat-status__message {
          color: color(gray-900);
        }

        .smd-profile-image {
          min-width: 60px;
          min-height: 60px;
          max-width: 60px;
          max-height: 60px;
        }
      }
    }
  }
</style>
